import apiService from '../apiService';

export const addTagTypes = ['DashboardStats'] as const;

export const reportsApi = apiService
	.enhanceEndpoints({
		addTagTypes
	})
	.injectEndpoints({
		endpoints: (build) => ({
		getMonthlyReport: build.query<any, any>({
			query: ({ search, page, per_page, month, year }) => ({
				url: `reporting/monthly-revenue`,
				params: { key_search: search, month, year, page, per_page, pagination: true }
			})
		}),
		getProductSalesReport: build.query<any, any>({
			query: ({ search, page, per_page, month, year }) => ({
				url: `reporting/sales-product`,
				params: { key_search: search, month, year, page, per_page, pagination: true }
			})
		}),
		getCustomerOverdueInvoicesReport: build.query<any, any>({
			query: ({ search, page, per_page, payment_term }) => ({
				url: `reporting/overdue-invoice`,
				params: { key_search: search, page, per_page, pagination: true, payment_term }
			})
		}),
		getSalePersonProductsReport: build.query<any, any>({
			query: ({ search, page, per_page, month, year }) => ({
				url: `reporting/sale-person-product`,
				params: { key_search: search, page, per_page, month, year, pagination: true }
			})
		}),
		getDashboardStatsReport: build.query<any, any>({
			query: ({ page, per_page, month, year, all }) => ({
				url: `reporting/dashboard-stats`,
				params: { page, per_page, month, year, pagination: true, all }
			})
		}),
	getDashboardStats: build.query<any, any>({
  query: () => ({
    url: 'reporting/dashboard',
  }),
  providesTags: ['DashboardStats'],
}),
		getDashboardGraph: build.query<any, any>({
			query: ({ year }) => ({
				url: `reporting/line-graph`,
				params: { year }
			})
		})
	})
})	

export const {
	useGetMonthlyReportQuery,
	useGetDashboardStatsReportQuery,
	useGetDashboardStatsQuery,
	useGetProductSalesReportQuery,
	useGetCustomerOverdueInvoicesReportQuery,
	useGetSalePersonProductsReportQuery,
	useGetDashboardGraphQuery
} = reportsApi;

export type Reports = {
	id: number;
	email: string;
	name: string;
	total_amount: number;
};

export type OverdueInvoices = {
	id: number;
	account_number: number;
	name: string;
	phone_number: string;
	address: string;
};

export type SalePersonProducts = {
	id: number;
	email: number;
	name: string;
	total_quantity: string;
	products: { product_name: string; total_quantity: string }[];
};
